import { Navigate } from "react-router-dom";
import AppLayout from "@/layouts/AppLayout";
import PageHeading from "@/components/PageHeading";
import DetailsCard from "@/components/DetailsCard";
import Switch from "@/components/Switch";
import usePageTitle from "@/hooks/usePageTitle";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { useColorScheme } from "@/providers/ColorSchemeProvider";

export default function SystemPreferencesPage() {
  usePageTitle("/preferences", "System Preferences");
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { colorScheme, setColorScheme } = useColorScheme();

  if (!flagsLoaded) {
    return null;
  }

  if (flags["backoffice-system-preferences"] !== true) {
    return <Navigate to="/" replace />;
  }

  return (
    <AppLayout interior>
      <div className="mx-auto max-w-3xl pb-12" data-testid="system-preferences-page">
        <PageHeading
          title="System Preferences"
          containerClassName="pt-6 lg:pt-8"
          titleClassName="text-sys-brand-on-surface text-headline-medium-bold font-serif lg:text-headline-large-bold"
        />
        <div className="mt-8">
          <DetailsCard heading="Appearance">
            <Switch
              headline="Dark Mode"
              supportingText="Use a darker color scheme in Member 360. This device remembers your choice."
              selected={colorScheme === "dark"}
              onChange={() => setColorScheme(colorScheme === "dark" ? "light" : "dark")}
            />
          </DetailsCard>
        </div>
      </div>
    </AppLayout>
  );
}
